type Props = {
  hidden?: {
    opacity?: number
    x?: number
    y?: number
    scale?: number
    height?: number | string
  }
  visible?: {
    opacity?: number
    x?: number
    y?: number
    scale?: number
    height?: number | string
  }
  exit?: {
    opacity?: number
    x?: number
    y?: number
    scale?: number
    height?: number | string
  }
  transition?: {
    type?: 'linear' | 'spring'
    bounce?: number
    duration?: number
    delay?: number
  }
  initial?: 'hidden' | 'visible'
  animate?: 'hidden' | 'visible'
}

const defaultHidden = { opacity: 0, x: 0, y: 30, scale: 0.8 }
const defaultVisible = { opacity: 1, x: 0, y: 0, scale: 1 }
const defaultTransition = {
  type: 'spring',
  bounce: 0,
  duration: 0.4,
  delay: 0,
}

function getDropInProps({ hidden, visible, exit, transition, initial = 'hidden', animate = 'visible' }: Props = {}) {
  return {
    variants: {
      hidden: { ...defaultHidden, ...hidden },
      visible: { ...defaultVisible, ...visible },
    },
    transition: { ...defaultTransition, ...transition },
    initial,
    animate,
    exit,
  }
}

export { getDropInProps }
